<div #map class="heremap-container" [style.width]="width" [style.height]="height"></div>

<ng-container>
  <div class="map-item" #bubbleContent>
    <curbnturf-search-display-card
      *ngIf="bubbleListing?.id"
      [point]="bubbleListing"
      defaultPhoto="/img/caravan-flat.svg"
      [force]="true"
      (closeBubble)="onCloseBubble()"
    >
    </curbnturf-search-display-card>
  </div>
</ng-container>

<ng-container>
  <div class="map-item" #bubbleBoondockContent>
    <curbnturf-boondock-search-display-card
      *ngIf="bubbleBoondock?.id"
      [point]="bubbleBoondock"
      defaultPhoto="/img/caravan-flat.svg"
      (closeBubble)="onCloseBubble()"
    >
    </curbnturf-boondock-search-display-card>
  </div>
</ng-container>

<ng-container>
  <div class="map-item" #bubbleActivityContent>
    <curbnturf-activity-card [activity]="currentActivity" (closeBubble)="onCloseBubble()"> </curbnturf-activity-card>
  </div>
</ng-container>

<ng-container>
  <div class="map-item" #bubbleUserPointContent>
    <curbnturf-user-point-card
      [userPoint]="currentUserPoint"
      (closeBubble)="onCloseBubble()"
      (userPointRemoved)="onUserPointRemoved($event)"
      (userPointUpdated)="onUserPointUpdated()"
    >
    </curbnturf-user-point-card>
  </div>
</ng-container>

<div class="context-menu" *ngIf="contextMenuVisible" #contextMenu>
  <curbnturf-here-map-context-menu
    [contextMenuCoordinates]="contextMenuCoordinates"
    (closeContextMenu)="clearContextMenu()"
  >
  </curbnturf-here-map-context-menu>
</div>
